import React from 'react'

import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from 'components/ui-builder/common/button'

import './recipe.css'

export interface IReadyForDD {
  backgroundColor: string
  question: string
  questionTextColor: string
  buttonProps: LinkButtonProp
}

const ReadyForDD = ({ backgroundColor, question, questionTextColor, buttonProps }: IReadyForDD) => {
  return (
    <div className="w-full py-8 text-center" style={{ backgroundColor: backgroundColor }}>
      <h3 style={{ color: questionTextColor }} className="mb-6 text-2xl sm:text-4xl">
        {question}
      </h3>
      <div className="w-full p-4 text-center">
        <LinkButton
          buttonColor={buttonProps?.buttonColor}
          buttonText={buttonProps?.buttonText}
          buttonTextColor={buttonProps?.buttonTextColor}
          loggedInButtonText={buttonProps?.loggedInButtonText}
          buttonUrl={buttonProps?.buttonUrl}
          isLink={buttonProps?.isLink}
          classList={
            'inline-block bg-white py-2 px-4 border border-transparent rounded-full text-base font-medium text-indigo-600 hover:bg-indigo-50 shadow w-full sm:w-fit'
          }
        />
      </div>
    </div>
  )
}

export default ReadyForDD

export const ReadyForDDProps = {
  name: 'readyForDDProps',
  type: 'object',
  defaultValue: {
    backgroundColor: 'lightblue',
    question: 'Main Description',
    questionTextColor: 'black',
    buttonProps: {}
  },
  subFields: [
    { name: 'backgroundColor', type: 'color', defaultValue: 'lightblue' },
    { name: 'question', type: 'string', defaultValue: 'Main Description' },
    { name: 'questionTextColor', type: 'color', defaultValue: 'black' },
    {
      ...LinkButtonRegisterProps
    }
  ]
}
